import dayjs from 'dayjs'
import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { AuthContext } from '@/contexts/AuthContext.js'

import { feedbackThresholdMinutes } from './_enums.js'
import { getPendingFeedback, isFeedbackAllowedPage } from './_services.js'
import UnitFeedBackModal from './components/Modal.jsx'

const UnitFeedback = () => {
    const { kalviumKc } = useContext(AuthContext)
    const location = useLocation()
    const feedbackChannel = new BroadcastChannel('feedback')

    const [isFeedbackModalVisible, setFeedbackModalVisible] = useState(false)
    const [feedbackSlot, setFeedbackSlot] = useState(null)
    const [feedbackType, setFeedbackType] = useState(null)

    useEffect(() => {
        // Listen for feedback-submission from other tabs
        feedbackChannel.onmessage = event => {
            if (event.data === 'feedbackSubmitted') {
                setFeedbackModalVisible(false)
            }
        }

        return () => {
            feedbackChannel.close()
        }
    }, [])

    useEffect(() => {
        const triggerFeedback = async () => {
            const pendingFeedback = await getPendingFeedback(kalviumKc)

            if (
                !pendingFeedback ||
                !Array.isArray(pendingFeedback.list) ||
                pendingFeedback.list.length === 0
            )
                return

            // student or mentor
            setFeedbackType(pendingFeedback.list[0]?.type)

            const slotEnd = dayjs(pendingFeedback.list[0]?.slot_end)

            // check for previous pending feedbacks
            if (slotEnd.isBefore(dayjs())) {
                setFeedbackModalVisible(true)
                setFeedbackSlot(pendingFeedback.list[0])
                return
            }

            // Check if the current time is within the threshold to show feedback
            if (
                dayjs().isAfter(
                    slotEnd.subtract(feedbackThresholdMinutes, 'minute')
                ) &&
                dayjs().isBefore(slotEnd)
            ) {
                setFeedbackModalVisible(true)
                setFeedbackSlot(pendingFeedback.list[0])
            }
        }

        if (isFeedbackAllowedPage(location.pathname)) {
            triggerFeedback()
            const interval = setInterval(triggerFeedback, 300000)
            return () => clearInterval(interval)
        }
    }, [location.pathname])
    return (
        <>
            {isFeedbackModalVisible && (
                <UnitFeedBackModal
                    FeedbackEntry={feedbackSlot}
                    feedbackType={feedbackType}
                    onClose={() => setFeedbackModalVisible(false)}
                />
            )}
        </>
    )
}

export default UnitFeedback
